import { PublicClientApplication } from "@azure/msal-browser";

let clientId = process.env.REACT_APP_AZURE_CLIENT_ID;
let tenantId = process.env.REACT_APP_AZURE_TENANT_ID;

const msalConfig = {
    auth: {
        clientId: clientId,
        authority: "https://login.microsoftonline.com/" + tenantId
    }
};

const authContext = new PublicClientApplication(msalConfig);

export async function authenticateToken() {

    const response = await authContext.handleRedirectPromise();

    if (response && response.account) {
        authContext.setActiveAccount(response.account);
        return true;
    }

    const accounts = authContext.getAllAccounts();

    if (accounts.length > 0) {
        authContext.setActiveAccount(accounts[0]);
        return true;
    }

    return false;
}

export async function loginRedirect() {

    return authContext.loginRedirect({
        scopes: [
            process.env.REACT_APP_API_SCOPE
        ]
    });
}
export async function getToken() {

    let account = authContext.getActiveAccount();

    if (!account) {
        const accounts = authContext.getAllAccounts();

        if (accounts.length > 0) {
            account = accounts[0];
            authContext.setActiveAccount(account);
        }
    }

    if (!account) {
        return null;
    }

    const tokenResponse = await authContext.acquireTokenSilent({
        account: account,
        scopes: [
            process.env.REACT_APP_API_SCOPE
        ]
    });

    return tokenResponse.accessToken;
}
export async function logout() {

    const account =
        authContext.getActiveAccount() ||
        authContext.getAllAccounts()[0];

    return authContext.logoutRedirect({
        account: account,
        postLogoutRedirectUri: window.location.origin
    });
}


// WEBPACK FOOTER //
// ./src/js/msalAuth.js